const $ = jQuery.noConflict();
import Global from './global';

'use strict';
let lastSegment = '';
if ($('.woocommerce-address-fields').length) {
	// check by last segment of url is it billing or shipping form
	lastSegment = location.href.split('/');
	lastSegment = lastSegment.pop() !== '' ? lastSegment.pop() : lastSegment[lastSegment.length - 1];
}

const AddressAutocomplete = {

	init: function() {
		// $('.js-register__form').keypress(
		// 	function(event) {
		// 		if (event.which == '13') {
		// 			event.preventDefault();
		// 		}
		// 	});

		// $("#autocomplete").focus().trigger('click');
		// $(".pac-container .pac-item:first").trigger('click');


		if ($('.register__wrapper').length || $('.woocommerce-address-fields').length) {
			google.maps.event.addDomListener(window, 'load', initAutocomplete);
		}

		const componentForm = {
			street_number: 'short_name',
			route: 'long_name',
			locality: 'long_name',
			postal_code: 'short_name',
		};

		function initAutocomplete() {
			if ($('.register__wrapper').length) {
				universal('autocomplete');
				universal('autocomplete2');
			}
			if ($('.woocommerce-address-fields').length) {
				universal(`${lastSegment}_address_1`);
			}
		}

		function universal(id) {

			let autocomplete; // eslint-disable-next-line prefer-const
			autocomplete = new google.maps.places.Autocomplete(
				document.getElementById(id),
				{types: ['geocode']}
			);

			autocomplete.setComponentRestrictions({
				country: ['us', 'ca']
			});

			autocomplete.setFields(['address_component']);
			autocomplete.addListener('place_changed', () => {
				fillInAddress(autocomplete, id);
			});
		}

		function fillInAddress(autocomplete, id) {
			const place = autocomplete.getPlace();
			const address = place.address_components.find(el => el.types[0] === 'route');
			const addressNum = place.address_components.find(el => el.types[0] === 'street_number');
			const country = place.address_components.find(el => el.types[0] === 'country');
			const state = place.address_components.find(el => el.types[0] === 'administrative_area_level_1');
			const addrSuffix = id === 'autocomplete' ? '' : '-shipping';

			// auto-populate some fields
			for (const component of place.address_components) {
				const addressType = component.types[0];
				if (!componentForm[addressType]) {
					continue;
				}
				const targetId = id === 'autocomplete' ? addressType : addressType + '2';
				if (document.getElementById(targetId)) {
					document.getElementById(targetId).value = component[componentForm[addressType]];
				}
			}

			// set "address" field if found
			const streetAddress = [];
			addressNum && streetAddress.push(addressNum.long_name);
			address && streetAddress.push(address.long_name);
			document.getElementById(id).value = streetAddress.join(' ');

			// set "country" field if found
			country && $('.js-register__country-dropdown' + addrSuffix)
				.val(country.short_name)
				.trigger('change.select2')    // update select2 visual
				.trigger('select2:select');// call handler to fill "states" list of options

			// set "state" field if found
			state && setTimeout(function() {
				$('.js-register__state-dropdown' + addrSuffix)
					.val(state.short_name)
					.trigger('change.select2');
			}, 100);

			if ($('.woocommerce-address-fields').length) {

				// zip code field
				const zipCode = place.address_components.find(el => el.types[0] === 'postal_code');
				if (zipCode) {
					const zipCodeName = zipCode.short_name ? zipCode.short_name : zipCode.long_name;
					$(`#${lastSegment}_postcode`).val(zipCodeName);
				}

				// country field
				const countryField = place.address_components.find(el => el.types[0] === 'country');
				if (countryField) {
					const countryFieldName = countryField.short_name ? countryField.short_name : countryField.long_name;
					$(`#${lastSegment}_country`).val(countryFieldName).trigger('change');
				}

				// city field
				const cityField = place.address_components.find(el => el.types[0] === 'locality');
				if (cityField) {
					const cityFieldName = cityField.short_name ? cityField.short_name : cityField.long_name;
					$(`#${lastSegment}_city`).val(cityFieldName);
				}

				// state field
				const stateField = place.address_components.find(el => el.types[0] === 'administrative_area_level_1');
				if (stateField) {
					const stateFieldName = stateField.short_name ? stateField.short_name : stateField.long_name;
					$(`#${lastSegment}_state`).val(stateFieldName).trigger('change');
				}
			}

		}
	},
};

export default AddressAutocomplete;
